import { initExclusiveRadioSubmitGuard } from '../shared/exclusive-radio-submit-guard';

/**
 * Toggles DisbursementDate / TransactionId / DenialReason field visibility and submit-button
 * state in the disbursement review modal based on the selected radio.
 */
export function initReviewDisbursementModal(): void {
    const modal = document.getElementById('reviewDisbursementModal');
    if (!modal) return;

    const approveFields = modal.querySelector<HTMLElement>('#approveFields');
    const denyFields = modal.querySelector<HTMLElement>('#denyFields');
    const denialTextarea = modal.querySelector<HTMLTextAreaElement>('#denialReason');
    const disbursementDate = modal.querySelector<HTMLInputElement>('#disbursementDate');

    initExclusiveRadioSubmitGuard(modal, 'decisionApprove', 'decisionDeny', 'reviewSubmitBtn', (isApprove, isDeny) => {
        approveFields?.classList.toggle('d-none', !isApprove);
        denyFields?.classList.toggle('d-none', !isDeny);

        if (denialTextarea) {
            denialTextarea.required = isDeny;
        }

        if (disbursementDate) {
            disbursementDate.required = isApprove;
        }
    });
}
